const getUrlKey = (url) => {
  url = decodeURIComponent(url).replace('?', '').split('&')
  let urlKeyArr = {}
  url.forEach(item => {
    if (item.substr(0, 5) == 'token') {
      urlKeyArr.token = item.substr(6, item.length - 1)
    } else {
      item.replace(/(.+)=(.+)/g, function (a, b, c) {
        urlKeyArr[b] = c
      })
    }
  })

  return urlKeyArr
}

export default getUrlKey



// WEBPACK FOOTER //
// ./src/utils/getUrlKey.js